module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ReferenceHandler":{"click_for_more_info":"Klicke für mehr..."}},"en":{"ReferenceHandler":{"click_for_more_info":"Click for more..."}}}')
  delete Component.options._Ctor
}
